import React from 'react'
import paths from 'data/paths.json'
import { ReactComponent as FacebookIcon } from 'svgs/facebook-icon-black.svg'
import { ReactComponent as TwitterIcon } from 'svgs/twitter-x-icon-white.svg'
import { ReactComponent as InstagramIcon } from 'svgs/instagram-icon-black.svg'
import { ReactComponent as YoutubeIcon } from 'svgs/youtube-icon-black.svg'
import { ReactComponent as TikTokIcon } from 'svgs/tiktok-icon-black.svg'

export default function Socials(){
    return(
        <div
            className='d-flex'
            css={{
                '& svg': { width: 16, height: 16 },
                '& path': { fill: 'white' },
                '& a:hover path': { opacity: .75 },
                '& a': {
                    padding: 16,
                    '@media(max-width: 375px)': { padding: 12 }
                },
            }}
        >
            <a href={paths.external.facebook} target='_blank' rel='noreferrer' className='d-flex a-center'><FacebookIcon /></a>
            <a href={paths.external.instagram} target='_blank' rel='noreferrer' className='d-flex a-center'><InstagramIcon /></a>
            <a href={paths.external.twitter} target='_blank' rel='noreferrer' className='d-flex a-center'><TwitterIcon /></a>
            <a href={paths.external.youtube} target='_blank' rel='noreferrer' className='d-flex a-center'><YoutubeIcon /></a>
        </div>
    )
}
